<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
    </teleport>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="flex justify-between items-center text-xl py-10">
                <Switcher v-model="tab_show" :options="['I miei budget', 'Tutti i budget']"></Switcher>
                <NextButton variant="primary" @click="visible=true"
                            class="ml-3 py-2 px-4 m-0 hidden sm:flex items-center">
                    + Aggiungi
                </NextButton>
            </div>
            <!--      <Grid :cols="cols" :rows="rows"></Grid>-->
            <div v-if="!tab_show">
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 py-5 table-fixed"
                               v-model:cols="budgetCols"
                               :rows="listaMyBudget.rows" @order-update="listaMyBudget.updateCols">

                        <template v-for="(c, j) in listaMyBudget.rows" :key="j" v-slot:[`td_${j}_2`]="context">
                            {{ $filters.toDate(context.context.row.data_inizio) }}
                        </template>

                        <template v-for="(c, j) in listaMyBudget.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                            {{ $filters.toDate(context.context.row.data_inizio) }}
                        </template>

                        <template v-for="(c, j) in listaMyBudget.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                            {{ budgetPreventivo(context.context.row.budget) }}
                        </template>

                    </NextTable>
                </div>
                <InfiniteLoading @infinite="listaMyBudget.fetchNextPage" :identifier="listaMyBudget.infiniteIdentifier"
                                 style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri clienti.</div>
                    </template>
                </InfiniteLoading>
            </div>
            <div v-else>
                <div class="rotate-x-180 overflow-x-scroll">
                    <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 py-5 table-fixed"
                               v-model:cols="budgetCols"
                               :rows="listaBudget.row" @order-update="listaBudget.updateCols">

                        <template v-for="(c, j) in listaBudget.row" :key="j" v-slot:[`td_${j}_2`]="context">
                            {{ $filters.toDate(context.context.row.data_inizio) }}
                        </template>

                        <template v-for="(c, j) in listaBudget.row" :key="j" v-slot:[`td_${j}_3`]="context">
                            {{ $filters.toDate(context.context.row.data_inizio) }}
                        </template>

                        <template v-for="(c, j) in listaBudget.row" :key="j" v-slot:[`td_${j}_4`]="context">
                            {{ budgetPreventivo(context.context.row.budget) }}
                        </template>

                    </NextTable>

                </div>
                <InfiniteLoading @infinite="listaBudget.fetchNextPage" :identifier="listaBudget.infiniteIdentifier"
                                 style="min-height: 1px">
                    <template #complete>
                        <div class="text-center pb-3">Non ci sono altri clienti.</div>
                    </template>
                </InfiniteLoading>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import AlertCard from "../components/AlertCard.vue";
import NextTable from "@/components/NextTable.vue";
import Paginator from "@/components/Paginator.vue";
import {Paths, TableOrder} from "@/types";
import {lista_clienti} from "@/BreadcrumbsPath";
import InfiniteLoading from "v3-infinite-loading";
import ConfermaModal from "@/components/ConfermaModal.vue";
import ContextMenu from "@/components/ContextMenu.vue";
import Loading from "@/components/Loading.vue";
import TopbarProgetti from "@/components/TopbarProgetti.vue";
import progettiManager from "../api/Progetti";
import Switcher from "@/components/Switcher.vue";
import NextButton from "@/components/NextButton.vue";
import Lista from "@/setup/ListaCerca";

@Options({
    name: 'ListaBudget',
    components: {
        NextButton,
        Switcher,
        TopbarProgetti,
        AlertCard,
        NextTable,
        Paginator,
        InfiniteLoading,
        ConfermaModal,
        ContextMenu,
        Loading,
    }
})
export default class ListaBudget extends Vue {

    tab_show = 1
    loading = false
    visible = false
    cm_visible = -1

    listaBudget: any = setup(() => Lista(progettiManager, this.budgetCols, progettiManager.progetti));

    listaMyBudget: any = setup(() => Lista(progettiManager, this.budgetCols, progettiManager.myProgetti));


    get getBreadcrumbsPath(): Paths[] {
        return lista_clienti
    }

    budgetPreventivo(b: string) {
        //@ts-ignore
        return b ? `${this.$filters.toCurrency(b)} €` : ''
    }

    mounted() {
        this.resetView()
    }

    resetView() {
        this.listaBudget.reset();
        this.listaMyBudget.reset();
    }

    onAddProgetto() {
        this.visible = false
        this.resetView()
    }

    budgetCols = [
        {
            name: 'Nome progetto',
            prop: 'titolo',
            orderable: true,
            class: 'text-left min-w-285 whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Azienda',
            prop: 'denominazione',
            orderable: true,
            class: 'text-left min-w-285 w-285 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data inizio',
            prop: 'data_inizio',
            orderable: true,
            class: 'text-left min-w-110 w-110 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data fine',
            prop: 'data_fine',
            orderable: true,
            class: 'text-left min-w-110 w-110 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Budget',
            prop: 'budget',
            orderable: true,
            class: 'text-left  min-w-110 w-110 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
    ]
}

</script>


<style lang="scss">

</style>
